import { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Container,
  Stack,
  Chip,
  Card,
  Typography,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { Api_Token } from "../../../env";
import PrintIcon from "@mui/icons-material/Print";
import ImageCard from "../../../composant/imageGallery/ImageGallrey";
import axios from "axios";
import { api_base } from "../../../env";
import PopupChangeBg from "../../../composant/Popup/PopupChangeBg";
import { ImportButton } from "../../../composant/UploadFiles";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import PopupEventWts from "../../../composant/Popup/PopupEventWts";
import CancelIcon from "@mui/icons-material/Cancel";
export default function PhotoPage() {
  const videoRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [image, setImage] = useState({
    file: null,
    srcRm: null,
    Bg: null,
    url: null,
  });
  const { Event } = useSelector((state) => state.Auth.user);
  const [hashtags, setHashtags] = useState([]);
  const [selectedHash, setSelectedHash] = useState(null);
  const [numberImpresssion, setNumberImpression] = useState(1);
  const [PopupChangeBgEtat, setPopupChangeBgEtat] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commandId, setCommandId] = useState(null);
  const [openWtsPopup, setOpenWtsPopup] = useState(false);
  const [SavedUrl, setSavedUrl] = useState("");
  const [showWelcome, setShowWelcome] = useState(true);
  const [timer, setTimer] = useState(null);
  const [srcRm, setSrcRm] = useState(null);
  const line1 = hashtags.filter((_, i) => i % 2 === 0);
  const line2 = hashtags.filter((_, i) => i % 2 !== 0); //

  const RemoveBgAndOpenPopup = useCallback(() => {
    setLoading(true);
    const formData = new FormData();
    formData.append("image", image.file);

    axios
      .post(`${api_base}images/RemoveBackground`, formData)
      .then((response) => {
        setSrcRm(response.data.image);
        //  setImage({ ...image, srcRm: response.data.image });
        //  setPopupChangeBgEtat(true);
      })
      .finally(() => {
        setLoading(false);
      });
  });
  useEffect(() => {
    console.log("Event.textImag :", Event.textImage);
    console.log(
      "status :",
      Event.id && (Event.textImage === "" || Event.textImage === null)
    );
    if (Event.id && Event.textImage === null) {
      Api_Token.get(`/HashTagsRoute/GetAllHashtagsEvent`).then((res) => {
        setHashtags(res.data.hashtagsList || []);
      });
    }
    if (Event.textImage) {
      setSelectedHash(Event.textImage);
    }

    return () => stopCamera();
  }, [Event]);

  useEffect(() => {
    if (srcRm === null && image.file && Event.Rm_Bg) {
      RemoveBgAndOpenPopup();
    }
  }, [image, RemoveBgAndOpenPopup]);

  async function startCamera() {
    try {
      const s = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "user" },
          width: { ideal: 1920, min: 1280 },
          height: { ideal: 1080, min: 720 },
        },
      });
      setStream(s);
      if (videoRef.current) videoRef.current.srcObject = s;
    } catch (err) {
      console.error("Camera Error:", err);
    }
  }

  function stopCamera() {
    stream?.getTracks().forEach((t) => t.stop());
  }

  function startTimer() {
    let count = 3;
    setTimer(count);

    const interval = setInterval(() => {
      count--;
      if (count === 0) {
        clearInterval(interval);
        setTimer(null);
        takePhoto();
      } else {
        setTimer(count);
      }
    }, 1000);
  }

  function takePhoto() {
    const video = videoRef.current;
    if (!video) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
        const url = URL.createObjectURL(file);

        setImage((prev) => ({
          ...prev,
          file,
          url,
        }));

        stopCamera();
      },
      "image/jpeg",
      0.99
    );
    //  RemoveBgAndOpenPopup();
  }

  function reset() {
    setImage({ file: null, srcRm: null, Bg: null, url: null });
    setSelectedHash(Event.textImage || null);
    setNumberImpression(1);
    setCommandId(null);
    setOpenWtsPopup(null);
    setSavedUrl(null);
    setSrcRm(null);
    startCamera();
  }

  function handleChangeBg(bg) {
    console.log("bg selected :", bg);
    setImage({ ...image, Bg: bg });
    setPopupChangeBgEtat(false);
  }

  const handlePrint = async () => {
    if (!image) return;

    const formData = new FormData();
    formData.append("image", image.file);
    formData.append("count", numberImpresssion);
    formData.append("idproduit", Event.idProduit);
    formData.append("text", selectedHash ? selectedHash : "");
    formData.append("srcRm", image.srcRm || null);
    formData.append("bg", image.Bg ? image.Bg.Url : null);
    setLoading(true);

    try {
      const response = await Api_Token.post(
        "/command/AddCommandEvent",
        formData
      );

      if (response.status === 200) {
        setCommandId(response.data.commandId);
        setSavedUrl(response.data.image_urls[0].urlOriginal);
        sendToPrint(response.data);
      }
    } catch (error) {
      console.error("Erreur :", error);
      setLoading(false);
    }
  };

  const sendToPrint = async (data) => {
    setLoading(true);
    try {
      await axios.post("https://192.168.1.4:5001/print_images_Event", data);
    } catch (error) {
      console.error("Erreur impression :", error);
    } finally {
      setLoading(false);
      setOpenWtsPopup(false);
      reset();
    }
  };

  function sendInfoAndOpen(data) {
    setLoading(true);
    const DataCommand = {
      ...data,
      NomClient: data.fullName,
      idCommand: commandId,
    };
    console.log("DataCommand :", DataCommand);

    Api_Token.post("command/AddCommandInfo", DataCommand)
      .then(() => {
        const message = `📸 ${Event.Nom}\nVoici votre photo :\n${SavedUrl}`;
        const text = encodeURIComponent(message);

        // Nettoyer numéro (enlever espaces)
        const phone = data.phone.replace(/\s+/g, "");

        // Ouvrir WhatsApp avec le numéro
        window.open(
          `https://api.whatsapp.com/send?phone=${data.phone}&text=${text}`,
          "_blank"
        );
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => {
        setLoading(false);
        reset();
      });
  }
  console.log("count ", numberImpresssion);
  console.log("image", image);
  console.log("selectedHash :", selectedHash);
  console.log("event :", Event);
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: showWelcome
          ? Event?.backgroundPageHomeUrl
            ? `url(${Event.backgroundPageHomeUrl})`
            : "#f5f5f5"
          : Event?.backgroundPageUrl
          ? `url(${Event.backgroundPageUrl})`
          : "#f5f5f5",

        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* شاشة البداية */}
      {showWelcome && (
        <Box
          onClick={() => {
            setShowWelcome(false);
            startCamera();
          }}
          sx={{
            position: "absolute",
            inset: 0,
            backgroundImage: "url('/bienvenue-bg.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 20,
            cursor: "pointer",
          }}
        >
          <Box
            sx={{
              background: "rgba(0,0,0,0.5)",
              padding: "20px 40px",
              borderRadius: "12px",
              color: "white",
              fontSize: "26px",
              fontWeight: "700",
            }}
          >
            Touchez l’écran pour commencer
          </Box>
        </Box>
      )}

      {/* FULLSCREEN CAMERA */}
      {!image.file && !showWelcome && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background: "#000",
            zIndex: 10,
          }}
        >
          <video
            ref={videoRef}
            autoPlay
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          {/* Timer */}
          {timer && (
            <Box
              sx={{
                position: "absolute",
                top: "40%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "180px",
                color: "white",
                fontWeight: "bold",
              }}
            >
              {timer}
            </Box>
          )}

          {/* زر التقاط الصورة */}
          <Box
            onClick={startTimer}
            sx={{
              position: "absolute",
              bottom: 100,
              left: "50%",
              transform: "translateX(-50%)",
              width: 150,
              height: 150,
              background: "rgba(255,0,0,0.8)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
          >
            <CameraAltIcon sx={{ fontSize: 70, color: "white" }} />
          </Box>
        </Box>
      )}

      {/* بعد أخذ الصورة */}
      <Container
        sx={{
          zIndex: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: "100vh",
        }}
      >
        {image.file && (
          <>
            {/* IMAGE BLOCK */}
            <Container maxWidth="sm" sx={{ marginTop: -15 }}>
              <Card sx={{ borderRadius: 3, overflow: "hidden" }}>
                <Box
                  sx={{
                    width: "100%",
                    background: Event?.backgroundImagePageUrl
                      ? `url(${Event.backgroundImagePageUrl})`
                      : Event?.BG_ImageCodeColor
                      ? Event.BG_ImageCodeColor
                      : "#ffffff",
                    backgroundSize: Event?.backgroundImagePageUrl
                      ? "resize"
                      : "auto",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    p: 5, // لإضافة مسافة داخلية حول الصورة
                  }}
                >
                  <Box sx={{ position: "relative", width: "100%" }}>
                    {/* لوغو في الأعلى يسار */}
                    {Event.logoImage && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 10,
                          left: 10,
                          zIndex: 10,
                          //  background: "rgba(255,255,255,0.6)",
                          padding: "6px 10px",
                          borderRadius: "8px",
                          backdropFilter: "blur(4px)",
                        }}
                      >
                        <img
                          src={Event.logoImage}
                          alt="logo"
                          style={{
                            width: 60,
                            height: "auto",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    )}

                    {/* ImageCard */}
                    <ImageCard
                      src={image.url}
                      DeleteDisplay={false}
                      type={Event?.Produit?.NomProduit}
                      badgeContent={numberImpresssion}
                      handleCountChange={(index, number) =>
                        setNumberImpression((prev) => number)
                      }
                      plusMarge={false}
                      Rm_bg={false}
                      changeBackground={() => {
                        if (srcRm) {
                          setImage({ ...image, srcRm: srcRm });
                          setPopupChangeBgEtat(true);
                        }
                      }}
                      srcRm={image.srcRm || false}
                      urlBg={image.Bg ? image.Bg.Url : false}
                      border={false}
                      changeIconPlace={true}
                    />
                  </Box>

                  <Typography
                    sx={{
                      textAlign: "center",
                      fontSize: "25px",
                      marginTop: 5,
                      fontWeight: "bold",
                    }}
                  >
                    {selectedHash}
                  </Typography>
                </Box>
              </Card>
            </Container>

            <Stack
              spacing={2}
              sx={{
                mt: 3,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "100%", // ← 90% FULL WIDTH
                  margin: "0 auto", // ← Center
                  overflowX: "auto",
                  overflowY: "hidden",
                  "&::-webkit-scrollbar": { height: 8 },
                  pb: 1,
                  background: "transparent",
                }}
              >
                {/* محتوى الهاشتاغات */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "max-content", // ← مهم للـ scroll
                    gap: 2,
                  }}
                >
                  {/* الخط الأول */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    {line1.map((h, i) => {
                      const isSelected = selectedHash === h.text;
                      return (
                        <Chip
                          key={i}
                          label={h.text}
                          onClick={() => setSelectedHash(h.text)}
                          sx={{
                            backgroundColor: isSelected ? "#E9535D" : "#fff",
                            color: isSelected ? "#fff" : "#000",
                            fontWeight: 700,
                            border: isSelected
                              ? "3px solid #fff"
                              : "2px solid #ccc",
                            cursor: "pointer",
                            fontSize: "26px",
                            padding: "25px 35px",
                            height: "70px",
                            borderRadius: "14px",

                            /* 🔒 FORCE SAME COLOR ON HOVER / FOCUS / ACTIVE */
                            "&:hover": {
                              backgroundColor: isSelected ? "#E9535D" : "#fff",
                            },
                            "&.Mui-focusVisible": {
                              backgroundColor: isSelected ? "#E9535D" : "#fff",
                            },
                            "&:active": {
                              backgroundColor: isSelected ? "#E9535D" : "#fff",
                            },
                          }}
                        />
                      );
                    })}
                  </Box>

                  {/* الخط الثاني */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    {line2.map((h, i) => {
                      const isSelected = selectedHash === h.text;
                      return (
                        <Chip
                          key={i}
                          label={h.text}
                          onClick={() => setSelectedHash(h.text)}
                          sx={{
                            backgroundColor: isSelected ? "#E9535D" : "#fff",
                            color: isSelected ? "#fff" : "#000",
                            fontWeight: 700,
                            border: isSelected
                              ? "3px solid #fff"
                              : "2px solid #ccc",
                            cursor: "pointer",
                            fontSize: "26px",
                            padding: "25px 35px",
                            height: "70px",
                            borderRadius: "14px",

                            /* 🔒 FORCE SAME COLOR ON HOVER / FOCUS / ACTIVE */
                            "&:hover": {
                              backgroundColor: isSelected ? "#E9535D" : "#fff",
                            },
                            "&.Mui-focusVisible": {
                              backgroundColor: isSelected ? "#E9535D" : "#fff",
                            },
                            "&:active": {
                              backgroundColor: isSelected ? "#E9535D" : "#fff",
                            },
                          }}
                        />
                      );
                    })}
                  </Box>
                </Box>
              </Box>
            </Stack>
            {Event.Rm_Bg && (
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mt: 3,
                  overflowX: "auto",
                  paddingBottom: 1,
                  "&::-webkit-scrollbar": { height: 8 },
                }}
              >
                {/* RESET BACKGROUND ITEM */}
                <Box
                  onClick={() => {
                    setImage({ ...image, Bg: null, srcRm: null });
                  }}
                  sx={{
                    width: 150,
                    height: 150,
                    borderRadius: "16px",
                    overflow: "hidden",
                    border: !image?.Bg ? "4px solid #E9535D" : "3px solid #fff",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#eee",
                  }}
                >
                  <Typography sx={{ fontSize: "22px", fontWeight: 700 }}>
                    Original
                  </Typography>
                </Box>

                {Event?.BackgroundEvents?.map((bg, index) => (
                  <Box
                    key={index}
                    onClick={() => {
                      console.log("src remove :", srcRm);
                      if (srcRm) {
                        console.log("src remove call true :");
                        setImage({ ...image, srcRm: srcRm, Bg: bg });
                        //  handleChangeBg(bg);
                      }
                    }}
                    sx={{
                      width: "auto",
                      height: 150,
                      borderRadius: "16px",
                      overflow: "hidden",
                      border:
                        image?.Bg?.Url === bg.Url
                          ? "4px solid #E9535D"
                          : "3px solid #fff",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src={bg.Url}
                      alt="bg-option"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            )}

            <Stack
              direction="row"
              spacing={2}
              sx={{
                position: "fixed",
                bottom: 10,
                left: 0,
                width: "100%",
                p: 2,
                //  background: "rgba(255,255,255,0.9)",
                zIndex: 1000,
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <Button
                sx={{
                  borderRadius: "16px",
                  height: "80px",
                  fontSize: "26px",
                  fontWeight: 900,
                  textTransform: "none",
                  width: "80%",
                }}
                fullWidth
                color="error"
                variant="contained"
                onClick={reset}
                startIcon={<CancelIcon sx={{ fontSize: "36px !important" }} />}
              >
                Reprendre
              </Button>

              <ImportButton
                sx={{
                  borderRadius: "16px",
                  height: "80px",
                  fontSize: "26px",
                  fontWeight: 900,
                  textTransform: "none",
                  width: "80%",
                }}
                //fullWidth
                variant="contained"
                onClick={handlePrint}
                startIcon={<PrintIcon sx={{ fontSize: "36px !important" }} />}
              >
                IMPRIMER
              </ImportButton>
            </Stack>
          </>
        )}
      </Container>

      <PopupChangeBg
        open={PopupChangeBgEtat}
        onClose={() => setPopupChangeBgEtat(false)}
        imageWithoutBg={image?.srcRm}
        bgList={Event?.BackgroundEvents || []}
        onSave={handleChangeBg}
      />

      <PopupEventWts
        open={openWtsPopup}
        onClose={() => {
          setOpenWtsPopup(false);
          reset();
        }}
        image={image.url}
        onSubmit={sendInfoAndOpen}
      />

      <BackLoadingSimple open={loading} />
    </Box>
  );
}
